import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import * as actions from '../actions';
import ListItem from './ListItem';
import { LuInbox } from 'react-icons/lu';
import  '../stylesheet/Messages.css';

class Messages extends Component {

    componentDidMount() {
      this.props.fetchMessages();
    }

    renderMessages() {
      const {data} = this.props;
      const messages = _.map(data, (value, key) => {
        return (<ListItem key={key} messageId={key} message={value} />);
      });
      if (!_.isEmpty(messages)) {
        return messages;
      }
      return (
        <div className="noItem">
          <LuInbox className="noItem-icon" aria-hidden="true" />
          <h4>You have no more messages</h4>
          <p>New messages from the contact form will show up here.</p>
        </div>
      );
    }

    render() {
        const {data} = this.props;
        const count = _.size(data);
        return(
          <div className='base'>
            <h1 className="sr-only">Admin Messages</h1>
            <span className="page-watermark" aria-hidden="true">Inbox</span>
            <div className="messages-header">
                <div>
                    <p className="messages-sub">{count} message{count === 1 ? '' : 's'} from the contact form</p>
                </div>
            </div>
            <div className="messages-list">
                {this.renderMessages()}
            </div>
          </div>
        );
    }
  }

  const mapStateToProps = ({data}) => {
    return {
      data
    }
  }

  export default connect(mapStateToProps, actions)(Messages);
